import { useShowSubscriber } from 'modules/for-verification/hooks';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatNumber } from 'helper';
import { useOrgIntegrationList } from '../hooks';

function Integration() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useOrgIntegrationList(filter, orgUuid);
  const format = [
    {
      label: 'integration',
      id: 'integration',
      key: 'project_name',
    },
    { label: 'attached mask name', id: 'attached_mask', key: 'sender_name' },
    {
      id: 'sms_utilization',
      label: 'SMS utilization',
      key: ({ sms_count, total_messages }) => (
        <span className="tabular-nums">
          {formatNumber(sms_count ?? total_messages ?? 0, 0)}
        </span>
      ),
      labelClassName: 'whitespace-nowrap flex justify-end',
      contentClassName: 'text-right',
    },
    { label: 'api key', id: 'api_key', key: 'token' },
  ];
  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default Integration;
